import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite'

/**
 * Singleton SQLite connection instance
 *
 * This ensures that all parts of the application use the same SQLite connection,
 * which is critical for tracking database connections and saving to the store.
 *
 * Import this instead of creating new SQLiteConnection instances:
 *
 * ```ts
 * import { sqlite } from 'src/shared/services/storage/local/sqliteConnection'
 * ```
 */
export const sqlite = new SQLiteConnection(CapacitorSQLite)
